import * as React from 'react';

import kebabCase from 'lodash/kebabCase';

import bigRunLogo from '@app/imageAssets/homePage/Big_run_logo.png';
import thumb1 from '@app/imageAssets/homePage/DEV_THUMBNAIL_01.jpg';
import thumb2 from '@app/imageAssets/homePage/DEV_THUMBNAIL_02.jpg';
import thumb3 from '@app/imageAssets/homePage/DEV_THUMBNAIL_03.jpg';
import thumb4 from '@app/imageAssets/homePage/DEV_THUMBNAIL_04.jpg';
import thumb5 from '@app/imageAssets/homePage/DEV_THUMBNAIL_05.jpg';
import thumb6 from '@app/imageAssets/homePage/DEV_THUMBNAIL_06.jpg';
import thumb7 from '@app/imageAssets/homePage/DEV_THUMBNAIL_07.jpg';
import thumb8 from '@app/imageAssets/homePage/DEV_THUMBNAIL_08.jpg';
import tetherLogo from '@app/imageAssets/homePage/Tether_Studios.png';
import poster from '@app/imageAssets/homePage/skillz_placeholder.jpg';
import SolitaireCube from '@app/imageAssets/homePage/solcubephone.png';
import StrikeBowling from '@app/imageAssets/homePage/strikebowling.png';

import {
  ICardInfo,
  ICaseStudy,
  IStatInfo,
  ICardDetailsStack,
  IRevenueCardInfo,
  IVideoDetails,
} from './interfaces';

export const CARDS: { [key: string]: ICardInfo } = {
  green: {
    color: 'green',
    title: '$$$$',
    name: '4X REVENUE',
    description: (
      <span>
        Our partnered creators see up to <span className="kpi-text-green">4X</span> growth in
        revenue after joining the Skillz platform.
      </span>
    ),
  },
  blue: {
    color: 'blue',
    title: '63+',
    name: 'MINUTES',
    description: (
      <span>
        Average time players spend daily on Skillz is <span className="kpi-text-blue">TWICE </span>
        the industry average.
      </span>
    ),
  },
  purple: {
    color: 'purple',
    title: '24%↑',
    name: 'RETENTION',
    description: (
      <span>
        Skillz games have <span className="kpi-text-purple">24%</span> more users playing for at
        least 30 days than the industry average.
      </span>
    ),
  },
};

export const STATS: { [key: string]: IStatInfo } = {
  developers: {
    title: '14K',
    description: 'Game developers launched game integrations on Skillz to date',
  },
  entries: {
    title: '$1.6B',
    description: 'Tournament entry fees on Skillz games in 2022',
  },
  mau: {
    title: '2.5M',
    description: 'Monthly Active Players across Skillz games in 2022',
  },
  time: {
    title: '2 Months',
    description: 'Average time to monetize your game after launching on Skillz',
  },
};

export const MONETIZE_DETAILS: { [key: string]: ICardDetailsStack } = {
  data: {
    title: 'Data & Analytics',
    color: 'purple',
    description:
      'Make better data-driven decisions for your game by accessing actionable data on Skillz Dev Console.',
  },
  revenue: {
    title: 'Transparent Revenue',
    color: 'blue',
    description:
      'Monitor your revenue in real-time through Skillz Dev Console and improve your earning potential.',
  },
  ops: {
    title: 'Live Ops & Marketing',
    color: 'pink',
    description:
      'Access to 24/7 Skillz player support. Engage players through live events, seasonal leagues, and much more.',
  },
  sdk: {
    title: 'Skillz SDK',
    color: 'black',
    description: 'Integrate the Skillz SDK to enable fair competition for real-world prizes.',
  },
  game: {
    title: 'Your Game',
    color: 'image',
    description: '',
  },
};

export const REVENUE_DETAILS: { [key: string]: IRevenueCardInfo } = {
  revenue: {
    title: (
      <span>
        {' '}
        Shared <br />
        Revenue Model{' '}
      </span>
    ),
    color: 'purple',
    description: (
      <span>
        Your revenue is a percentage <br />
        of the player entry fees in <br />
        your game tournaments
      </span>
    ),
  },
  potential: {
    title: (
      <span>
        Immense <br />
        potential to scale
      </span>
    ),
    color: 'blue',
    description: (
      <span>
        Earn between 50% and 94% <br />
        of the available revenue as <br />
        you bring more quality traffic <br />
        to your game
      </span>
    ),
  },
  earnings: {
    title: (
      <span>
        Access <br />
        to earnings
      </span>
    ),
    color: 'green',
    description: (
      <span>
        Monitor your revenue on the <br />
        Skillz Dev Console in <br />
        real-time
      </span>
    ),
  },
};

export const INLINE_VIDEOS: { [key: string]: IVideoDetails } = {
  born: {
    quote: '"You were born to create games. We exist to realize their potential."',
    company: 'CEO & Founder of Skillz',
    companyLogoUrl: '', // leave blank to show logo
    name: 'Andrew Paradise',
    title: '',
    description: '',
    videoUrl: `https://cdn.skillz.com/portal-developer/landing-page/Skillz_Andrew.mp4`,
    posterUrl: `${poster}`,
    isSelfHosted: true,
  },
  bigRun: {
    quote:
      '"At Big Run, we are obsessed with our players and building hit games for them. Skillz is the very foundation of how we achieve that. Not only has the platform provided access to a network of passionate competitive players, but it has also help us to achieve some incredible financial results."',
    company: '',
    companyLogoUrl: `${bigRunLogo}`,
    name: 'Andrew Bell',
    title: 'Founder & CEO',
    description: '',
    videoUrl: `https://cdn.skillz.com/portal-developer/landing-page/big_run_video.mp4`,
    posterUrl: `${poster}`,
    isSelfHosted: true,
  },
  tether: {
    quote:
      '"From the time Tether was created until the time we started working with Skillz, it was basically an expensive hobby. Afterward, we were able to turn it into a business. That is when we started building the company around Skillz."',
    company: '',
    companyLogoUrl: `${tetherLogo}`,
    name: "Tim O'neil and Aletheia O'neil",
    title: 'Founders',
    description: '',
    videoUrl: `https://cdn.skillz.com/portal-developer/landing-page/Skillz_Tether_video_case_study_nov23_240131.mp4`,
    posterUrl: `${poster}`,
    isSelfHosted: true,
  },
};

export const VIDEO_TUTORIALS: { [key: string]: IVideoDetails } = {
  videoOne: {
    quote: '',
    company: '',
    companyLogoUrl: `${thumb1}`, // use for image
    name: 'Skillz',
    title: 'Developer Console Overview',
    description:
      "In this Skillz Developer Tutorial Series video, you'll learn to set up your developer account and get a quick introduction to the Skillz Developer Console.",
    videoUrl: `https://www.youtube.com/embed/JvaIY9d29A0`,
    posterUrl: `${poster}`,
    isSelfHosted: false,
    relatedVideos: ['videoTwo', 'videoThree'],
  },
  videoTwo: {
    quote: '',
    company: '',
    companyLogoUrl: `${thumb2}`, // use for image
    name: 'Skillz',
    title: 'SDK Set Up',
    description:
      "In this Skillz Developer Tutorial Series video, you'll learn to create your game on the Developer Console, configure it, and import the Skillz SDK into your Unity Game.",
    videoUrl: `https://www.youtube.com/embed/IUwZeSKwMPg`,
    posterUrl: `${poster}`,
    isSelfHosted: false,
    relatedVideos: ['videoThree', 'videoFour'],
  },
  videoThree: {
    quote: '',
    company: '',
    companyLogoUrl: `${thumb3}`, // use for image
    name: 'Skillz',
    title: 'Implement Skillz UI',
    description:
      "In this Skillz Developer Tutorial Series video, you'll learn to set up the Skillz Manager, launch Skillz UI, then test your game in SIDEkick.",
    videoUrl: `https://www.youtube.com/embed/GCPP9E2KVMg`,
    posterUrl: `${poster}`,
    isSelfHosted: false,
    relatedVideos: ['videoFour', 'videoFive'],
  },
  videoFour: {
    quote: '',
    company: '',
    companyLogoUrl: `${thumb4}`, // use for image
    name: 'Skillz',
    title: 'Implement Core Loop',
    description:
      "In this Skillz Developer Tutorial Series video, you'll learn to set up the Core Loop of your game, including score submission, returning to the Skillz UI and fallback score submission.",
    videoUrl: `https://www.youtube.com/embed/2GGIX884lOo`,
    posterUrl: `${poster}`,
    isSelfHosted: false,
    relatedVideos: ['videoFive', 'videoSix'],
  },
  videoFive: {
    quote: '',
    company: '',
    companyLogoUrl: `${thumb5}`, // use for image
    name: 'Skillz',
    title: 'Fairness',
    description:
      "In this Skillz Developer Tutorial Series video, you'll learn about the role Fairness plays in all Skillz games, and how to ensure it in yours using the Skillz Random Number Generator (RNG).",
    videoUrl: `https://www.youtube.com/embed/Ue30NlQr-jI`,
    posterUrl: `${poster}`,
    isSelfHosted: false,
    relatedVideos: ['videoSix', 'videoSeven'],
  },
  videoSix: {
    quote: '',
    company: '',
    companyLogoUrl: `${thumb6}`, // use for image
    name: 'Skillz',
    title: 'Building to Sandbox (iOS)',
    description:
      "In this Skillz Developer Tutorial Series video, you'll learn to build your game to the Sandbox for iOS devices.",
    videoUrl: `https://www.youtube.com/embed/tzqeDmB0iow`,
    posterUrl: `${poster}`,
    isSelfHosted: false,
    relatedVideos: ['videoSeven', 'videoEight'],
  },
  videoSeven: {
    quote: '',
    company: '',
    companyLogoUrl: `${thumb7}`, // use for image
    name: 'Skillz',
    title: 'Building to Sandbox (Android)',
    description:
      "In this Skillz Developer Tutorial Series video, you'll learn to build your game to the Sandbox for Android devices.",
    videoUrl: `https://www.youtube.com/embed/QGXfiYrFHIA`,
    posterUrl: `${poster}`,
    isSelfHosted: false,
    relatedVideos: ['videoEight'],
  },
  videoEight: {
    quote: '',
    company: '',
    companyLogoUrl: `${thumb8}`, // use for image
    name: 'Skillz',
    title: 'Building and Uploading Your Game',
    description:
      "In this Skillz Developer Tutorial Series video, you'll learn to build and upload your game binary to Skillz Platform.",
    videoUrl: `https://www.youtube.com/embed/zeMIcnD_xWo`,
    posterUrl: `${poster}`,
    isSelfHosted: false,
  },
};

export const CASE_STUDIES: ICaseStudy[] = [
  {
    publisherName: 'Tether Studios',
    users: [
      { firstName: 'Tim', lastName: '' },
      { firstName: 'Ether', lastName: '' },
    ],
    image: (
      <img
        src={SolitaireCube}
        id={`publisher-image-${kebabCase('Tether Studios')}`}
        alt="Solitaire Cube Game using Skillz system on a smart phone"
      />
    ),
    stats: [
      { title: 'Average Minutes in App', value: '65' },
      { title: 'ARPDAU', value: '$0.68' },
      { title: 'Conversion to Paying User', value: '32%' },
    ],
    testimonial:
      'With the Skillz platform, we were easily able to add a competitive spin to Solitaire Cube that,\
      in turn, increased our monetization and provided an ad-free experience for our users',
    caseStudyLink: 'https://www.skillz.com/developers/#solitairecube',
    altDescription: 'Solitaire Cube Game using Skillz system on a smart phone',
  },
  {
    publisherName: '',
    users: [{ firstName: 'Carl', lastName: 'Crossley', title: 'Co-Founder' }],
    image: (
      <img
        src={StrikeBowling}
        id={`publisher-image-${kebabCase('Touch Mechanics')}`}
        alt="Strike Bowling Game using Skillz system on a smart phone"
      />
    ),
    stats: [
      { title: 'Incremental Annual Revenue', value: '$259k+' },
      { title: 'ARPDAU', value: '$0.52' },
      { title: 'Conversion to Paying User', value: '17%' },
    ],
    testimonial:
      'We’re still amazed that something this easy to integrate can produce such incredible results. \
      It’s safe to say that we’ll be adding the Skillz platform to our other games. Honestly, it’s hard \
      to imagine how this solution did not exist before.',
    caseStudyLink: 'https://www.skillz.com/developers/#strikebowling',
    altDescription: 'Strike Bowling Game using Skillz system on a smart phone',
  },
];
